import React                                            from "react";
import {block}                                          from "../block";
import {UiSchemaEntry, DataCellType, ColumnCellType}    from "../@types";
import {useLocale} from '@sirius/ui-lib/src/subjects/Locale/useLocale';
import {ELocales} from '@sirius/ui-lib/src/subjects/Locale';

const formatNumber = (maybeNumStr: string | number, locale: ELocales): string=> {
    const maybeNum = parseFloat(`${maybeNumStr}`.trim() );
    if ( isFinite(maybeNum) && !Number.isNaN(maybeNum) ) {
        return new Intl.NumberFormat(locale, {style: "decimal"}).format(maybeNum);
    }
    return '';
}

const DataCell:React.FC<DataCellType> = ({data}) => {
    const locale = useLocale();
    return  <span className={block.el('datacell-name') + block.el('datacell-number')}>
                {
                    formatNumber(data, locale)
                }
            </span>
};

const ColumnCell:React.FC<ColumnCellType> = ({column: {name, title}}) =>
    <span className={block.el('columncell-name') + block.el('columncell-number')}>
        {title || name}
    </span>
;

const number: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {number}
